import { Box } from "@mui/material";
import { PageHeader, SearchField } from "components/layout/PageHeader";
import SearchFilters from "components/SearchFilters";
import { Board } from "core/board";
import { AddCandidateModal } from "core/board/components/candidateModal";
import { useEffect, useState } from "react";

export function RegistrationsPage() {
  const [search, setSearch] = useState<string | null>(null);
  const [filters, setFilters] = useState<{ qualification?: string[] }>({});
  const [searchTerm, setSearchTerm] = useState<string | null>('');

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
        setSearch(searchTerm);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const hasFilters = filters.qualification && filters.qualification.length > 0;

  return (
    <>
      <PageHeader title="Candidats" actions={<AddCandidateModal />}>
        <SearchField
          value={searchTerm ?? ''}
          onChange={setSearchTerm}
          placeholder="Rechercher un candidat"
          trailing={<SearchFilters onFiltersUpdate={(newFilters) => setFilters(newFilters)} currentFiltersCount={hasFilters ? 1 : 0} />}
        />
      </PageHeader>
      <Box
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          paddingX: "1rem",
          paddingY: "1rem",
          width: "calc(100vw - 16rem)",
          height: "calc(100vh - 72px)",
          overflowY: "hidden",
          overflowX: "auto",
        }}
      >
        <Board
          search={search}
          filters={filters}
        />
      </Box>
    </>
  );
}
